import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api/axios.config';
import { notify } from '../utils/methods/notification';

const initialState = {
    isLoading: false,
    allProductCalculation: [],
    ProductCalculationDropdown: [],
    addModal: false
};

// fetch all Leukapheresis conditions
export const fetchAllProductCalculations = createAsyncThunk(
    'bmr/fetchAllProductCalculation',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post('/product_date_calculation/list',data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// add Leukapheresis condition
export const addProductCalculation = createAsyncThunk(
    'bmr/addProductCalculation',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.post('/product_date_calculation/create', args);
            notify.success(response.data.message);
            dispatch(disableAddModal());
            dispatch(fetchAllProductCalculations());
            return response.data;
        } catch (error) {
            notify.error(error || error.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// edit Leukapheresis condition
export const editProductCalculation = createAsyncThunk(
    'bmr/editProductCalculation',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { data, editId } = args;
            const response = await api.put(`/product_date_calculation/update/${editId}`, data);
            notify.success(response.data.message);
            dispatch(disableAddModal());
            dispatch(fetchAllProductCalculations());
            return response.data;
        } catch (error) {
            notify.error(error?.message || error);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// delete Leukapheresis condition
export const deleteProductCalculation = createAsyncThunk(
    'bmr/deleteProductCalculation',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { id } = args;
            const response = await api.delete(`/product_date_calculation/delete/${id}`);
            notify.success(response.data.message);
            dispatch(fetchAllProductCalculations());
            return response.data;
        } catch (error) {
            notify.error(error?.message || error);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);


const BmrProductCalculationSlice = createSlice({
    name: 'BmrProductCalculation',
    initialState,
    reducers: {
        enableAddModal(state) {
            state.addModal = true;
        },
        disableAddModal(state) {
            state.addModal = false;
        },
    },
    extraReducers: (builder) => {
        builder
            // fetch
            .addCase(fetchAllProductCalculations.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllProductCalculations.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allProductCalculation = action.payload.data;
            })
            .addCase(fetchAllProductCalculations.rejected, (state) => {
                state.isLoading = false;
            })
            // add
            .addCase(addProductCalculation.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(addProductCalculation.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(addProductCalculation.rejected, (state) => {
                state.isLoading = false;
            })
            // edit
            .addCase(editProductCalculation.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(editProductCalculation.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(editProductCalculation.rejected, (state) => {
                state.isLoading = false;
            })
            // delete
            .addCase(deleteProductCalculation.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteProductCalculation.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteProductCalculation.rejected, (state) => {
                state.isLoading = false;
            })
    },
});

export const { disableAddModal, enableAddModal } = BmrProductCalculationSlice.actions;

export const selectProductCalculationDropdown = (state) => state.BmrProductCalculation.ProductCalculationDropdown;
export const selectProductCalculationLoading = (state) => state.BmrProductCalculation.isLoading;
export const selectProductCalculationAll = (state) => state.BmrProductCalculation.allProductCalculation;
export const selectBmraddProductCalculationModal = (state) => state.BmrProductCalculation.addModal;

export default BmrProductCalculationSlice.reducer;
